import { render, staticRenderFns } from "./InsuranceVerifications.vue?vue&type=template&id=475dd238"
import script from "./InsuranceVerifications.vue?vue&type=script&lang=js"
export * from "./InsuranceVerifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports